import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Check from "./Check.svg";
import Form from "./form";
import GridRadio from "./gridradio";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Title from "./title";
import poweredChoices, { poweredLevels } from "./poweredChoices";

export default function BatteryPoweredMembership({ mediaQuery, page, total, person }) {
  const isCIR = person !== undefined ? person.membership_type === 'Creative in Residence' : false;
  const nextUrl = isCIR ? "/apply/community" : "/apply/references";
  const submitUrl = "/api/applications/v4/application/battery_powered_membership/";
  const {
    data: {
      results: [
        {
          submission: {
            battery_powered_membership: { battery_powered_type }
          }
        }
      ]
    }
  } = useQuery(["application"]);
  const [form, setForm] = useState({ battery_powered_type, errors: null });
  const choices = poweredLevels.concat([
    {
      id: poweredChoices.LEARN_MORE.id,
      name: poweredChoices.LEARN_MORE.name,
      description: ["I'd like to speak to someone and find out more"],
      intro: ""
    },
    {
      id: poweredChoices.NOT_SET.id,
      name: poweredChoices.NOT_SET.name,
      description: ["I’m interested in philanthropy, but not sure if I’m ready to commit yet"],
      intro: ""
    }
  ]);
  return (
    <Page>
      <PageHeader
        title={`APPLICATION PAGE ${page} OF ${total}`}
        tagline="Activate your generosity."
      >
        <P>Join Battery Powered to start making impactful changes today!</P>
      </PageHeader>
      <Title>Select an option</Title>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} submitUrl={submitUrl}>
        <GridRadio
          name="battery_powered_type"
          form={form}
          setForm={setForm}
          isTabletOrMobile={mediaQuery.isTabletOrMobile}
          choices={choices.filter((n) => (!isCIR) || (isCIR && n.id !== poweredChoices.LEARN_MORE.id)).map((n) => ({
            id: n.id,
            name: n.name,
            intro: n.intro,
            description: n.description.map((m, idx) => (
              <div
                key={idx}
                style={{
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "left",
                  marginBottom: "1rem"
                }}
              >
                <div style={{ marginRight: "1rem" }}>
                  <Check />
                </div>
                <div style={{ textAlign: "left" }}>{m}</div>
              </div>
            ))
          }))}
        />
        <P>
          Read more about the information we collect in our{" "}
          <a
            style={{ textDecoration: "underline" }}
            href="/privacy-policy/#battery-powered"
            target="_blank"
          >
            Privacy Policy
          </a>
        </P>
      </Form>
    </Page>
  );
}
